/** Avoid CSS selector issues with line keys (e.g. colons); match dataset exactly. */
function cartRowsForKey(key) {
	const k = String(key);
	return Array.from(document.querySelectorAll('.cartItem')).filter(
		el => el.dataset.cartItemId === k
	);
}

function quantityInputsForKey(key) {
	const k = String(key);
	return Array.from(document.querySelectorAll('.jsCartItemQuantity')).filter(
		el => el.dataset.cartItemId === k
	);
}

function escapeHtml(text) {
	if (text == null) return '';
	return String(text)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

function escapeHtmlAttr(text) {
	if (text == null) return '';
	return String(text)
		.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
		.replace(/</g, '&lt;');
}

/** e.g. /en-us/collections/all → /en-us (Shopify Markets / languages). */
function deriveLocalePrefixFromPathname() {
	try {
		const path = window.location.pathname;
		const m = path.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)(?=\/)/i);
		if (m && m[1].length > 1) {
			return m[1].replace(/\/$/, '');
		}
	} catch (e) {
		/* ignore */
	}
	return '';
}

/** Locale-aware cart Ajax paths. Prefer Shopify.routes (matches storefront). */
function cartApiUrl(endpoint) {
	const path = String(endpoint).replace(/^\//, '');
	let root = '';
	if (
		typeof Shopify !== 'undefined' &&
		Shopify.routes &&
		Shopify.routes.root != null
	) {
		root = String(Shopify.routes.root);
	} else if (typeof window !== 'undefined' && window.__CART_API_ROOT__ != null) {
		root = String(window.__CART_API_ROOT__);
	}
	root = root.replace(/\/$/, '');
	if (!root) {
		const fromPath = deriveLocalePrefixFromPathname();
		if (fromPath) {
			return `${fromPath}/${path}`;
		}
		return '/' + path;
	}
	return `${root}/${path}`;
}

function tryParseCartJson(text) {
	try {
		return JSON.parse(text);
	} catch {
		return null;
	}
}

function throwCartResponseError(response, text) {
	const data = tryParseCartJson(text);
	if (data !== null && !response.ok) {
		throw new Error(
			data.description || data.message || 'Could not update your cart.'
		);
	}
	const snippet = String(text).slice(0, 120).trim();
	const looksLikeHtml =
		snippet.startsWith('<') || snippet.toUpperCase().includes('<!DOCTYPE');
	throw new Error(
		looksLikeHtml
			? 'The store could not update your cart. Please refresh the page.'
			: 'Could not update your cart.'
	);
}

/**
 * Update line quantity: change.js, then update.js if the response is not JSON.
 * If removing the last line and both fail JSON, try clear.js when cart has one item.
 */
async function postCartLineQuantity(lineKey, quantity) {
	const headers = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'X-Requested-With': 'XMLHttpRequest',
	};
	const creds = { credentials: 'same-origin' };

	let response = await fetch(cartApiUrl('cart/change.js'), {
		...creds,
		method: 'POST',
		headers,
		body: JSON.stringify({ id: String(lineKey), quantity }),
	});
	let text = await response.text();
	let data = tryParseCartJson(text);

	if (data !== null) {
		if (!response.ok) {
			throw new Error(
				data.description ||
					data.message ||
					'Could not update your cart.'
			);
		}
		return data;
	}

	response = await fetch(cartApiUrl('cart/update.js'), {
		...creds,
		method: 'POST',
		headers,
		body: JSON.stringify({
			updates: { [String(lineKey)]: quantity },
		}),
	});
	text = await response.text();
	data = tryParseCartJson(text);

	if (data !== null) {
		if (!response.ok) {
			throw new Error(
				data.description ||
					data.message ||
					'Could not update your cart.'
			);
		}
		return data;
	}

	if (quantity === 0) {
		const stateRes = await fetch(cartApiUrl('cart.js'), {
			...creds,
			headers: { Accept: 'application/json' },
		});
		const stateText = await stateRes.text();
		const state = tryParseCartJson(stateText);
		if (state && state.item_count === 1) {
			response = await fetch(cartApiUrl('cart/clear.js'), {
				...creds,
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
			});
			text = await response.text();
			data = tryParseCartJson(text);
			if (data !== null) {
				if (!response.ok) {
					throw new Error(
						data.description ||
							data.message ||
							'Could not update your cart.'
					);
				}
				return data;
			}
		}
	}

	throwCartResponseError(response, text);
}

function variantOptionAtPicker(variant, index) {
	if (!variant) return undefined;
	if (Array.isArray(variant.options) && variant.options[index] !== undefined) {
		return variant.options[index];
	}
	const key = 'option' + (index + 1);
	return variant[key];
}

function variantMatchesPartialPicker(variant, selections) {
	for (let j = 0; j < selections.length; j++) {
		const s = selections[j];
		if (s != null && s !== '' && variantOptionAtPicker(variant, j) !== s) {
			return false;
		}
	}
	return true;
}

/** Canonical size order; keep in sync with snippets/sort-size-option-values.liquid */
const SIZE_OPTION_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];

function normalizeSizeLabelForSort(s) {
	return String(s || '')
		.trim()
		.toUpperCase()
		.replace(/[\s_-]+/g, '');
}

function isSizeOptionNamePicker(name) {
	const n = String(name || '').trim().toLowerCase();
	if (n === 'size' || n === 'sizes') return true;
	if (n.includes('one-size') || n.includes('one size')) return false;
	return n.includes('size');
}

function sizeValueSortIndex(value) {
	let n = normalizeSizeLabelForSort(value);
	if (n === 'XXL') n = '2XL';
	if (n === 'XXS') n = 'XS';
	const idx = SIZE_OPTION_ORDER.findIndex(
		x => normalizeSizeLabelForSort(x) === n
	);
	return idx === -1 ? 1000 : idx;
}

function sortSizeValuesList(values) {
	return [...values].sort((a, b) => {
		const ia = sizeValueSortIndex(a);
		const ib = sizeValueSortIndex(b);
		if (ia !== ib) return ia - ib;
		return String(a).localeCompare(String(b), undefined, {
			sensitivity: 'base',
		});
	});
}

function sortOptionValuesForPicker(optionName, values) {
	if (isSizeOptionNamePicker(optionName)) {
		return sortSizeValuesList(values);
	}
	return [...values].sort((a, b) =>
		String(a).localeCompare(String(b), undefined, { sensitivity: 'base' })
	);
}

function findAvailableVariantBySelections(variants, selections) {
	if (!selections.every(s => s != null && s !== '')) return null;
	const v = variants.find(v =>
		selections.every((s, i) => variantOptionAtPicker(v, i) === s)
	);
	return v && v.available ? v : null;
}

class CartManager {
	constructor() {
		this.cartPopOut = document.getElementById('cartPopOut');
		this.cartIcon = document.getElementById('cartIcon');
		this.cartForm = document.getElementById('cartForm');
		this.cartItemsContainer = document.getElementById('cartItemsContainer');
		this.init();
	}

	init() {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => {
				this.initializeComponents();
			});
		} else {
			this.initializeComponents();
		}
	}

	initializeComponents() {
		this.cartPopOut = document.getElementById('cartPopOut');
		this.cartIcon = document.getElementById('cartIcon');
		this.cartForm = document.getElementById('cartForm');
		this.cartItemsContainer = document.getElementById('cartItemsContainer');

		this.initCartPopOut();
		this.setupEventListeners();
		this.updateCartCountFromShopify();
	}

	initCartPopOut() {
		if (!this.cartPopOut) return;

		const triggers = document.querySelectorAll('.js-open-cart');
		this.toggleCartPopOutBound = this.toggleCartPopOut.bind(this);
		triggers.forEach(el => {
			el.removeEventListener('click', this.toggleCartPopOutBound);
			el.addEventListener('click', this.toggleCartPopOutBound);
		});

		// Close button
		const closeButton = document.getElementById('closeCart');
		if (closeButton) {
			closeButton.removeEventListener('click', this.closeCartPopOutBound);
			this.closeCartPopOutBound = this.closeCartPopOut.bind(this);
			closeButton.addEventListener('click', this.closeCartPopOutBound);
		}

		// Click outside to close
		document.removeEventListener('click', this.handleOutsideClickBound);
		this.handleOutsideClickBound = this.handleOutsideClick.bind(this);
		document.addEventListener('click', this.handleOutsideClickBound);
	}

	toggleCartPopOut(e) {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		if (this.cartPopOut) {
			this.cartPopOut.classList.toggle('active');
			if (this.cartPopOut.classList.contains('active')) {
				this.refreshCartPopOut();
			}
		}
		return false;
	}

	closeCartPopOut() {
		if (this.cartPopOut) {
			this.cartPopOut.classList.remove('active');
		}
	}

	handleOutsideClick(e) {
		if (e.target.closest('#quickAddPicker')) return;
		if (
			this.cartPopOut &&
			this.cartPopOut.classList.contains('active') &&
			!this.cartPopOut.contains(e.target) &&
			!e.target.closest('.js-open-cart')
		) {
			this.cartPopOut.classList.remove('active');
		}
	}

	setupEventListeners() {
		console.log('Setting up cart event listeners');

		// Helper function to attach listeners to a container
		const attachListeners = container => {
			if (!container) return;

			// Quantity decrease buttons
			container.addEventListener('click', e => {
				const decreaseBtn = e.target.closest('.jsQuantityDecrease');
				if (decreaseBtn) {
					e.preventDefault();
					e.stopPropagation();
					this.handleDecrease(decreaseBtn);
				}
			});

			// Quantity increase buttons
			container.addEventListener('click', e => {
				const increaseBtn = e.target.closest('.jsQuantityIncrease');
				if (increaseBtn) {
					e.preventDefault();
					e.stopPropagation();
					this.handleIncrease(increaseBtn);
				}
			});

			// Remove buttons
			container.addEventListener('click', e => {
				const removeBtn = e.target.closest('.jsCartItemRemove');
				if (removeBtn) {
					e.preventDefault();
					e.stopPropagation();
					this.handleRemove(removeBtn);
				}
			});

			// Quantity input changes
			container.addEventListener('change', e => {
				const input = e.target.closest('.jsCartItemQuantity');
				if (input) {
					this.handleQuantityChange(input);
				}
			});

			// Handle Enter key on quantity inputs
			container.addEventListener('keypress', e => {
				const input = e.target.closest('.jsCartItemQuantity');
				if (input && e.key === 'Enter') {
					e.preventDefault();
					this.handleQuantityChange(input);
				}
			});
		};

		// Attach to main cart container (if it exists)
		if (this.cartItemsContainer) {
			attachListeners(this.cartItemsContainer);
		}

		// Attach to cart popout container (if it exists)
		if (this.cartPopOut) {
			attachListeners(this.cartPopOut);
		}

		// Quick add (single-variant AJAX; multi-variant opens option picker)
		document.addEventListener('click', e => {
			const quickAddBtn = e.target.closest('.quickAddButton');
			if (!quickAddBtn) return;
			e.preventDefault();
			e.stopPropagation();
			if (quickAddBtn.dataset.productJson) {
				this.openQuickAddPicker(quickAddBtn);
				return;
			}
			this.handleQuickAdd(quickAddBtn);
		});
	}

	handleRemove(button) {
		const itemKey = button.dataset.cartItemId;
		if (!itemKey) return;

		const cartItem = button.closest('.cartItem');
		if (cartItem) {
			cartItem.classList.add('updating');
		}

		this.updateCartItem(itemKey, 0);
	}

	handleQuantityChange(input) {
		const key = input.dataset.cartItemId;
		if (!key) return;

		let quantity = parseInt(input.value, 10);

		if (isNaN(quantity) || quantity < 0) {
			quantity = 0;
		}

		const max = parseInt(input.getAttribute('max') || 99, 10);
		if (quantity > max) {
			quantity = max;
		}

		quantityInputsForKey(key).forEach(el => {
			el.value = quantity;
		});

		console.log(`Quantity changed for item ${key} to ${quantity}`);
		this.updateCartItem(key, quantity);
	}

	handleDecrease(button) {
		const key = button.dataset.cartItemId;
		if (!key) return;

		const row = button.closest('.cartItem');
		const input = row
			? row.querySelector('.jsCartItemQuantity')
			: quantityInputsForKey(key)[0];
		if (!input) return;

		let quantity = parseInt(input.value, 10) - 1;
		if (quantity >= 0) {
			input.value = quantity;
			quantityInputsForKey(key).forEach(el => {
				el.value = quantity;
			});
			this.updateCartItem(key, quantity);
		}
	}

	handleIncrease(button) {
		const key = button.dataset.cartItemId;
		if (!key) return;

		const row = button.closest('.cartItem');
		const input = row
			? row.querySelector('.jsCartItemQuantity')
			: quantityInputsForKey(key)[0];
		if (!input) return;

		let quantity = parseInt(input.value, 10) + 1;
		const max = parseInt(input.getAttribute('max') || 99, 10);

		if (quantity <= max) {
			input.value = quantity;
			quantityInputsForKey(key).forEach(el => {
				el.value = quantity;
			});
			this.updateCartItem(key, quantity);
		}
	}

	ensureQuickAddPicker() {
		if (this._pickerRoot) return;

		const root = document.createElement('div');
		root.id = 'quickAddPicker';
		root.className = 'quickAddPicker';
		root.hidden = true;
		root.innerHTML = `
			<div class="quickAddPicker__backdrop" aria-hidden="true"></div>
			<div class="quickAddPicker__panel" role="dialog" aria-modal="true" aria-labelledby="quickAddPickerTitle">
				<div class="quickAddPicker__header">
					<h2 id="quickAddPickerTitle" class="quickAddPicker__title"></h2>
					<button type="button" class="quickAddPicker__close" aria-label="Close">&times;</button>
				</div>
				<div class="quickAddPicker__body"></div>
				<div class="quickAddPicker__footer">
					<p class="quickAddPicker__priceRow" hidden>
						<span class="quickAddPicker__priceLabel">Price: </span>
						<strong class="quickAddPicker__price"></strong>
					</p>
					<button type="button" class="quickAddPicker__add">~ Add to cart ~</button>
					<a href="#" class="quickAddPicker__detailsLink">View full product details</a>
				</div>
			</div>
		`;
		document.body.appendChild(root);

		this._pickerRoot = root;
		this._pickerPanel = root.querySelector('.quickAddPicker__panel');
		this._pickerTitle = root.querySelector('.quickAddPicker__title');
		this._pickerBody = root.querySelector('.quickAddPicker__body');
		this._pickerAdd = root.querySelector('.quickAddPicker__add');
		this._pickerPriceRow = root.querySelector('.quickAddPicker__priceRow');
		this._pickerPrice = root.querySelector('.quickAddPicker__price');
		this._pickerDetailsLink = root.querySelector('.quickAddPicker__detailsLink');

		root.querySelector('.quickAddPicker__backdrop').addEventListener('click', () => {
			this.closeQuickAddPicker();
		});
		root.querySelector('.quickAddPicker__close').addEventListener('click', () => {
			this.closeQuickAddPicker();
		});
		this._pickerAdd.addEventListener('click', () => {
			this.completeQuickAddPicker();
		});

		this._pickerBody.addEventListener('click', e => {
			const btn = e.target.closest('.quickAddPicker__valueBtn');
			if (!btn || btn.disabled) return;
			const idx = parseInt(btn.dataset.optionIndex, 10);
			const val = btn.dataset.optionValue;
			if (Number.isNaN(idx) || val === undefined) return;
			this.onQuickAddOptionPick(idx, val);
		});

		this._onPickerEscape = e => {
			if (e.key === 'Escape' && this._pickerRoot && !this._pickerRoot.hidden) {
				this.closeQuickAddPicker();
			}
		};
		document.addEventListener('keydown', this._onPickerEscape);
	}

	closeQuickAddPicker() {
		if (!this._pickerRoot || this._pickerRoot.hidden) return;
		if (this._onPickerViewportResize) {
			window.removeEventListener('resize', this._onPickerViewportResize);
			this._onPickerViewportResize = null;
		}
		this.unbindQuickAddAnchoredListeners();
		this._pickerRoot.classList.remove('quickAddPicker--anchored');
		if (this._pickerPanel) {
			this._pickerPanel.style.cssText = '';
		}
		this._pickerRoot.hidden = true;
		document.body.style.overflow = '';
		if (this._pickerTrigger) {
			this._pickerTrigger.setAttribute('aria-expanded', 'false');
			this._pickerTrigger.focus();
			this._pickerTrigger = null;
		}
		this._pickerContext = null;
		if (this._pickerAdd) {
			this._pickerAdd.hidden = false;
			this._pickerAdd.disabled = false;
			this._pickerAdd.textContent = '~ Add to cart ~';
		}
		if (this._pickerPriceRow) {
			this._pickerPriceRow.hidden = true;
		}
	}

	unbindQuickAddAnchoredListeners() {
		if (!this._anchoredListenersBound) return;
		this._anchoredListenersBound = false;
		if (this._boundRepositionQuickAdd) {
			window.removeEventListener('scroll', this._boundRepositionQuickAdd, true);
		}
		if (this._boundOutsideQuickAdd) {
			document.removeEventListener(
				'pointerdown',
				this._boundOutsideQuickAdd,
				true
			);
		}
	}

	bindQuickAddAnchoredListeners() {
		if (this._anchoredListenersBound) return;
		this._anchoredListenersBound = true;

		this._boundRepositionQuickAdd = () => {
			if (
				!this._pickerRoot ||
				this._pickerRoot.hidden ||
				!this._pickerRoot.classList.contains('quickAddPicker--anchored')
			) {
				return;
			}
			this.positionQuickAddAnchoredPanel();
		};

		this._boundOutsideQuickAdd = e => {
			if (
				!this._pickerRoot ||
				this._pickerRoot.hidden ||
				!this._pickerRoot.classList.contains('quickAddPicker--anchored')
			) {
				return;
			}
			const t = e.target;
			if (this._pickerPanel && this._pickerPanel.contains(t)) return;
			const tr = this._pickerTrigger;
			if (tr && (tr === t || tr.contains(t))) return;
			this.closeQuickAddPicker();
		};

		window.addEventListener('scroll', this._boundRepositionQuickAdd, true);
		document.addEventListener(
			'pointerdown',
			this._boundOutsideQuickAdd,
			true
		);
	}

	updateQuickAddPickerLayout() {
		if (!this._pickerRoot || this._pickerRoot.hidden) return;
		const desktop = window.matchMedia('(min-width: 64rem)').matches;
		if (desktop) {
			document.body.style.overflow = '';
			this._pickerRoot.classList.add('quickAddPicker--anchored');
			this.bindQuickAddAnchoredListeners();
			requestAnimationFrame(() => {
				requestAnimationFrame(() => this.positionQuickAddAnchoredPanel());
			});
		} else {
			this.unbindQuickAddAnchoredListeners();
			this._pickerRoot.classList.remove('quickAddPicker--anchored');
			if (this._pickerPanel) {
				this._pickerPanel.style.cssText = '';
			}
			document.body.style.overflow = 'hidden';
		}
	}

	positionQuickAddAnchoredPanel() {
		if (
			!this._pickerRoot ||
			!this._pickerPanel ||
			!this._pickerTrigger ||
			!this._pickerRoot.classList.contains('quickAddPicker--anchored')
		) {
			return;
		}

		const anchor =
			this._pickerTrigger.closest('.productCard, .product-card') ||
			this._pickerTrigger.closest('.quickAddSlot') ||
			this._pickerTrigger;
		const rect = anchor.getBoundingClientRect();
		const panel = this._pickerPanel;
		const vw = window.innerWidth;
		const vh = window.innerHeight;
		const pad = 12;
		const gap = 12;

		panel.style.visibility = 'hidden';
		panel.style.left = '0';
		panel.style.top = '0';

		const w = panel.offsetWidth || 320;
		const h = panel.offsetHeight || 200;

		let left = rect.right + gap;
		if (left + w > vw - pad) {
			left = rect.left - gap - w;
		}
		if (left < pad) {
			left = pad;
		}
		if (left + w > vw - pad) {
			left = Math.max(pad, vw - pad - w);
		}

		let top = rect.top;
		if (top + h > vh - pad) {
			top = vh - pad - h;
		}
		if (top < pad) {
			top = pad;
		}

		panel.style.left = `${Math.round(left)}px`;
		panel.style.top = `${Math.round(top)}px`;
		panel.style.visibility = '';
	}

	openQuickAddPicker(button) {
		this.ensureQuickAddPicker();
		const raw = button.dataset.productJson;
		const productUrl = button.dataset.productUrl || '/';
		let product;
		try {
			product = JSON.parse(raw);
		} catch (err) {
			console.error('Quick add picker: invalid product JSON', err);
			window.location.href = productUrl;
			return;
		}

		const rawOptions = product.options || [];
		const optionNames = rawOptions.map(o =>
			typeof o === 'string' ? o : o && o.name ? o.name : ''
		);
		const variants = product.variants || [];
		const n = optionNames.length;

		if (n === 0) {
			window.location.href = productUrl;
			return;
		}

		this._pickerTrigger = button;
		button.setAttribute('aria-expanded', 'true');

		this._pickerContext = {
			product,
			productUrl,
			variants,
			optionNames,
			optionCount: n,
			selections: Array(n).fill(null),
			matchedVariant: null,
		};

		this._pickerTitle.textContent = product.title || 'Choose options';
		this._pickerDetailsLink.href = productUrl;

		if (!product.available || n === 0) {
			this._pickerBody.innerHTML =
				'<p class="quickAddPicker__msg">This product is not available to add right now. You can still open the product page to check details.</p>';
			this._pickerAdd.hidden = true;
			this._pickerPriceRow.hidden = true;
		} else {
			this._pickerAdd.hidden = false;
			this.renderQuickAddPickerPanel();
		}

		this._pickerRoot.hidden = false;
		this._onPickerViewportResize = () => {
			if (!this._pickerRoot || this._pickerRoot.hidden) return;
			this.updateQuickAddPickerLayout();
		};
		window.addEventListener('resize', this._onPickerViewportResize);
		this.updateQuickAddPickerLayout();
		this._pickerRoot.querySelector('.quickAddPicker__close').focus();
	}

	onQuickAddOptionPick(optionIndex, value) {
		const ctx = this._pickerContext;
		if (!ctx) return;
		ctx.selections[optionIndex] = value;
		for (let j = optionIndex + 1; j < ctx.optionCount; j++) {
			ctx.selections[j] = null;
		}
		this.renderQuickAddPickerPanel();
	}

	renderQuickAddPickerPanel() {
		const ctx = this._pickerContext;
		if (!ctx || !this._pickerBody) return;

		const { variants, optionNames, optionCount: n, selections } = ctx;
		if (n === 0) return;

		let html = '';
		for (let i = 0; i < n; i++) {
			const name = optionNames[i] || `Option ${i + 1}`;
			const allVals = sortOptionValuesForPicker(
				name,
				[
					...new Set(
						variants
							.filter(v => v.available)
							.map(v => variantOptionAtPicker(v, i))
							.filter(Boolean)
					),
				]
			);

			html += `<fieldset class="quickAddPicker__optionBlock"><legend class="quickAddPicker__optionName">${escapeHtml(name)}</legend><div class="quickAddPicker__values">`;

			for (const val of allVals) {
				const testSel = selections.slice();
				testSel[i] = val;
				const viable = variants.some(
					v => v.available && variantMatchesPartialPicker(v, testSel)
				);
				const selected = selections[i] === val;
				const disabled = viable ? '' : ' disabled';
				const selClass = selected ? ' is-selected' : '';
				html += `<button type="button" class="quickAddPicker__valueBtn${selClass}" data-option-index="${i}" data-option-value="${escapeHtmlAttr(val)}"${disabled}>${escapeHtml(val)}</button>`;
			}

			html += `</div></fieldset>`;
		}

		this._pickerBody.innerHTML = html;

		const matched = findAvailableVariantBySelections(variants, selections);
		ctx.matchedVariant = matched;

		const allChosen = selections.every(s => s != null && s !== '');
		if (matched && allChosen) {
			this._pickerPriceRow.hidden = false;
			this._pickerPrice.textContent = this.formatMoney(matched.price);
			this._pickerAdd.disabled = false;
		} else {
			this._pickerPriceRow.hidden = true;
			this._pickerAdd.disabled = true;
		}

		if (this._pickerRoot.classList.contains('quickAddPicker--anchored')) {
			requestAnimationFrame(() => {
				requestAnimationFrame(() => this.positionQuickAddAnchoredPanel());
			});
		}
	}

	async completeQuickAddPicker() {
		const ctx = this._pickerContext;
		if (!ctx || !ctx.matchedVariant) return;

		const btn = this._pickerAdd;
		btn.disabled = true;
		btn.textContent = '~ Adding... ~';

		try {
			await this.quickAdd(ctx.matchedVariant.id);
			btn.textContent = '~ Added! ~';
			this.closeQuickAddPicker();
			if (this.cartPopOut) {
				this.cartPopOut.classList.add('active');
				await this.refreshCartPopOut();
			}
		} catch (error) {
			console.error('Quick add picker:', error);
			alert(error.message || 'Could not add to cart');
			btn.disabled = false;
			btn.textContent = '~ Add to cart ~';
		}
	}

	async handleQuickAdd(button) {
		const variantId =
			button.dataset.variantId || button.dataset.productId;
		if (!variantId) {
			console.warn('Quick add: missing variant id');
			return;
		}
		const originalText = button.textContent;

		button.textContent = 'Adding...';
		button.disabled = true;

		try {
			await this.quickAdd(variantId);
			button.textContent = '✓ Added!';
			setTimeout(() => {
				button.textContent = originalText;
				button.disabled = false;
			}, 2000);
		} catch (error) {
			console.error('Error adding to cart:', error);
			button.textContent = 'Error';
			setTimeout(() => {
				button.textContent = originalText;
				button.disabled = false;
			}, 2000);
		}
	}

	async updateCartItem(key, quantity) {
		console.log(`Updating cart item: ${key} to quantity ${quantity}`);

		const lineKey = String(key);
		const cartItems = cartRowsForKey(lineKey);
		cartItems.forEach(el => el.classList.add('updating'));

		try {
			const cart = await postCartLineQuantity(lineKey, quantity);
			console.log('Cart updated:', cart);

			cartItems.forEach(el => el.classList.remove('updating'));

			this.updateCartCount(cart.item_count);
			this.updateCartTotals(cart);
			this.updateFreeShippingBar(cart);

			if (quantity === 0 && cartItems.length) {
				cartItems.forEach(cartItem => {
					cartItem.style.transition = 'opacity 0.3s, transform 0.3s';
					cartItem.style.opacity = '0';
					cartItem.style.transform = 'translateX(-20px)';
				});

				setTimeout(() => {
					cartRowsForKey(lineKey).forEach(el => el.remove());
					if (cart.item_count === 0) {
						window.location.reload();
					}
				}, 300);
			}

			if (this.cartPopOut && this.cartPopOut.classList.contains('active')) {
				await this.refreshCartPopOut();
			}
		} catch (error) {
			console.error('Error updating cart:', error);
			cartRowsForKey(lineKey).forEach(el =>
				el.classList.remove('updating')
			);
			alert(error.message || 'Error updating cart. Please try again.');
			this.revertQuantity(lineKey);
		}
	}

	async quickAdd(variantId, quantity = 1) {
		try {
			const response = await fetch(cartApiUrl('cart/add.js'), {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify({
					id: Number(variantId) || variantId,
					quantity: quantity,
				}),
			});

			const text = await response.text();
			let data;
			try {
				data = JSON.parse(text);
			} catch {
				const snippet = text.slice(0, 120).trim();
				const looksLikeHtml =
					snippet.startsWith('<') ||
					snippet.toUpperCase().includes('<!DOCTYPE');
				throw new Error(
					looksLikeHtml
						? 'Could not add to cart. Please refresh and try again.'
						: 'Could not add this item to your cart.'
				);
			}
			if (!response.ok) {
				throw new Error(
					data.description || data.message || 'Could not add to cart'
				);
			}
			await this.refreshCartData();

			// Show cart popout if it exists
			if (this.cartPopOut) {
				this.cartPopOut.classList.add('active');
				await this.refreshCartPopOut();
			}

			return data;
		} catch (error) {
			console.error('Error adding to cart:', error);
			throw error;
		}
	}

	async refreshCartData() {
		try {
			const response = await fetch(cartApiUrl('cart.js'), {
				credentials: 'same-origin',
			});
			const cart = await response.json();

			this.updateCartCount(cart.item_count);
			this.updateCartTotals(cart);
			this.updateFreeShippingBar(cart);
			this.checkEmptyCart(cart);

			return cart;
		} catch (error) {
			console.error('Error refreshing cart:', error);
		}
	}

	async refreshCartPopOut() {
		if (!this.cartPopOut) return;

		try {
			const response = await fetch(cartApiUrl('cart.js'), {
				credentials: 'same-origin',
			});
			const cart = await response.json();

			const itemsContainer =
				this.cartPopOut.querySelector('.cartPopOutItems');
			const footer = this.cartPopOut.querySelector('.cartPopOutFooter');

			if (!itemsContainer) return;

			if (cart.item_count === 0) {
				itemsContainer.innerHTML =
					'<div class="emptyCart"><p>~ Your Cart is Empty ~</p></div>';
				if (footer) footer.style.display = 'none';
			} else {
				if (footer) footer.style.display = 'block';

				// Build items HTML
				let itemsHtml = '';
				cart.items.forEach((item, index) => {
					const rawKey = String(item.key);
					const keyAttr = escapeHtmlAttr(rawKey);
					const qtyId = `cart-popout-qty-${index}`;
					const updatesNameAttr = escapeHtmlAttr(`updates[${rawKey}]`);

					const variantTitle =
						item.variant_title && item.variant_title !== 'Default Title'
							? item.variant_title
							: '';
					const variantText = variantTitle
						? `<p class="cartItemVariant">${escapeHtml(variantTitle)}</p>`
						: '';

					const displayTitle = escapeHtml(
						item.product_title || item.title || ''
					);
					const plainTitle = item.title || item.product_title || '';
					const imgAlt = escapeHtmlAttr(plainTitle);
					const imgSrc =
						typeof item.image === 'string'
							? escapeHtmlAttr(item.image)
							: item.image && typeof item.image.url === 'string'
								? escapeHtmlAttr(item.image.url)
								: '';

					itemsHtml += `
                    <div class="cartItem" data-cart-item-id="${keyAttr}">
                        <div class="cartItemImage">
                            ${
											imgSrc
												? `<img src="${imgSrc}" alt="${imgAlt}" loading="lazy" width="80" height="80">`
												: '<div class="placeholder-svg">Product Image</div>'
										}
                        </div>
                        <div class="cartItemDetails">
                            <h4>${displayTitle}</h4>
                            ${variantText}
                            <p class="cartItemPrice">${this.formatMoney(item.price)}</p>
                            <div class="cartItemQuantity">
                                <label for="${qtyId}">Qty:</label>
                                <div class="quantitySelector mini">
                                    <button type="button" 
                                            class="quantityButton decrease jsQuantityDecrease" 
                                            data-cart-item-id="${keyAttr}"
                                            aria-label="Decrease quantity">
                                        <span>−</span>
                                    </button>
                                    <input type="number" 
                                           name="${updatesNameAttr}"
                                           id="${qtyId}"
                                           value="${item.quantity}" 
                                           min="0"
                                           max="99"
                                           data-cart-item-id="${keyAttr}" 
                                           class="jsCartItemQuantity quantityInput"
                                           aria-label="Product quantity">
                                    <button type="button" 
                                            class="quantityButton increase jsQuantityIncrease" 
                                            data-cart-item-id="${keyAttr}"
                                            aria-label="Increase quantity">
                                        <span>+</span>
                                    </button>
                                </div>
                            </div>
                            <button type="button" 
                                    class="cartItemRemove jsCartItemRemove" 
                                    data-cart-item-id="${keyAttr}"
                                    aria-label="Remove item">
                                Remove
                            </button>
                        </div>
                    </div>
                `;
				});

				itemsContainer.innerHTML = itemsHtml;

				this.ensureCartPopOutSubtotalRow();
				const totalEl = this.cartPopOut.querySelector('.cartTotalAmount');
				if (totalEl) {
					totalEl.textContent = this.formatMoney(cart.total_price);
				}
			}

			// Update free shipping bar if it exists
			const freeShippingBar =
				this.cartPopOut.querySelector('.freeShippingBar');
			if (freeShippingBar) {
				this.updateFreeShippingBar(cart);
			}

			// No need to reattach listeners - event delegation handles it
		} catch (error) {
			console.error('Error refreshing cart popout:', error);
		}
	}

	ensureCartPopOutSubtotalRow() {
		if (!this.cartPopOut) return;
		const row = this.cartPopOut.querySelector('.cartPopOutFooter .cartTotal');
		if (!row || row.querySelector('.cartTotalAmount')) return;
		row.innerHTML =
			'<span>Subtotal:</span><span class="cartTotalAmount"></span>';
	}

	updateCartCount(count) {
		console.log('Updating cart count to:', count);

		// Update cart icon
		if (this.cartIcon) {
			const countSpan = this.cartIcon.querySelector('.cartCount');
			if (countSpan) {
				countSpan.textContent = count;
			} else {
				this.cartIcon.innerHTML = `~ Cart (${count}) ~`;
			}
		}

		// Update any other cart count elements
		document.querySelectorAll('.cartCount, .cart-count').forEach(el => {
			el.textContent = count;
		});
	}

	updateCartTotals(cart) {
		console.log('Updating cart totals:', cart.total_price);

		// Main cart page (sections/main-cart.liquid)
		const subtotalElement = document.querySelector('.cartSubtotal');
		if (subtotalElement) {
			subtotalElement.textContent = this.formatMoney(cart.total_price);
		}

		const mainCartTotal = document.querySelector(
			'.cartTotals .total strong.cartTotal'
		);
		if (mainCartTotal) {
			mainCartTotal.textContent = this.formatMoney(cart.total_price);
		}

		// Cart pop-out: never set textContent on div.cartTotal — it removes the
		// label + .cartTotalAmount spans and breaks updates (see refreshCartPopOut).
		this.ensureCartPopOutSubtotalRow();
		document.querySelectorAll('.cartTotalAmount').forEach(el => {
			el.textContent = this.formatMoney(cart.total_price);
		});

		cart.items.forEach(item => {
			cartRowsForKey(item.key).forEach(itemElement => {
				const itemTotal = itemElement.querySelector(
					'.itemTotal, .cartItemTotal strong, .itemTotal strong'
				);
				if (itemTotal) {
					itemTotal.textContent = this.formatMoney(item.final_line_price);
				}
			});
		});
	}

	updateFreeShippingBar(cart) {
		const shippingBar = document.querySelector('.freeShippingBar');
		if (!shippingBar) return;

		const freeShippingAmount = parseInt(
			shippingBar.dataset.freeShippingAmount || 5000
		);
		const cartTotal = cart.total_price;
		const remaining = freeShippingAmount - cartTotal;
		const progressBar = shippingBar.querySelector('.shippingProgressBar');

		if (progressBar) {
			const percentage = Math.min(
				(cartTotal / freeShippingAmount) * 100,
				100
			);
			progressBar.style.width = percentage + '%';
		}

		const messageElement = shippingBar.querySelector('.shippingMessage');
		if (messageElement) {
			if (remaining > 0) {
				messageElement.innerHTML = `Only <strong>${this.formatMoney(remaining)}</strong> more for free shipping!`;
			} else {
				messageElement.innerHTML = '~ FREE SHIPPING! ~';
			}
		}
	}

	checkEmptyCart(cart) {
		const cartContainer = document.querySelector('.cartItemsContainer');
		const emptyCartDiv = document.querySelector('.emptyCart');
		const cartFooter = document.querySelector('.cartFooter');

		if (cart.item_count === 0) {
			if (cartContainer) cartContainer.style.display = 'none';
			if (emptyCartDiv) emptyCartDiv.style.display = 'block';
			if (cartFooter) cartFooter.style.display = 'none';
		} else {
			if (cartContainer) cartContainer.style.display = 'block';
			if (emptyCartDiv) emptyCartDiv.style.display = 'none';
			if (cartFooter) cartFooter.style.display = 'block';
		}
	}

	revertQuantity(key) {
		const lineKey = String(key);
		fetch(cartApiUrl('cart.js'), { credentials: 'same-origin' })
			.then(response => response.text())
			.then(text => {
				try {
					return JSON.parse(text);
				} catch {
					return { items: [] };
				}
			})
			.then(cart => {
				const item = cart.items.find(i => String(i.key) === lineKey);
				if (item) {
					quantityInputsForKey(lineKey).forEach(input => {
						input.value = item.quantity;
					});
				}
			});
	}

	formatMoney(cents) {
		if (!cents && cents !== 0) return '$0.00';
		const dollars = cents / 100;
		return '$' + dollars.toFixed(2);
	}

	updateCartCountFromShopify() {
		fetch(cartApiUrl('cart.js'), { credentials: 'same-origin' })
			.then(response => response.json())
			.then(cart => {
				this.updateCartCount(cart.item_count);
				this.updateCartTotals(cart);
			})
			.catch(error => console.error('Error fetching cart:', error));
	}
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		window.cartManager = new CartManager();
	});
} else {
	window.cartManager = new CartManager();
}
